import React from 'react';
import RicosViewer from './ricos-viewer';
import styles from './ricos-viewer-wrapper.scss';
const RicosViewerWrapper = (props) => {
    const { isMobile, TextSelectionToolbar, TwitterButton, isTwitterEnabled } = props;
    const [viewerRef, setViewerRef] = React.useState(null);
    return (React.createElement("div", { className: styles.relativeContainer },
        React.createElement(RicosViewer, { ...props, setViewerRef: setViewerRef }),
        isTwitterEnabled && !isMobile ? (React.createElement(TextSelectionToolbar, { container: viewerRef }, (selectedText) => React.createElement(TwitterButton, { selectedText: selectedText }))) : null));
};
export default RicosViewerWrapper;
//# sourceMappingURL=ricos-viewer-wrapper.js.map